/*******************************************************************************
 * Copyright (c) 2024 Belltane LLC
 *
 * All rights reserved.
 *
 * Contributors:
 *   Amina Rais - Initial implementation
 *
 * Version: 1.0.0
 *
 *******************************************************************************/

import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';

import Container from '@mui/material/Container';

import Button from '@mui/material/Button'
import { Divider } from '@mui/material';



const Home = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const googlePlayLink = 'https://play.google.com/store/apps/details?id=com.belltane.pictitude';
  const appStoreLink = 'https://apps.apple.com/app/pictitude/id6503367653';
  const youtubeChannelLink = 'https://www.youtube.com/@Pictitude';


  return (

    <Grid container maxWidth="xl">

      <Grid item className={classes.container} xs={12} sm={12} md={12}>

        <div className={classes.heroContent}>
          <Grid container maxWidth="xl">

            <Grid item xs={12} sm={12} md={5}>

              <Container className={classes.cardGrid} maxWidth="xl">
                <div >
                  <Typography className={classes.bigHeaderTypo}  >
                    {t('titles:wlc')}
                  </Typography>
                  <Typography className={classes.bigHeadersubtitle}
                  >
                    {t('titles:tagline')}
                  </Typography>
                  <Grid container maxWidth="xl" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                    <Grid item xs={12} sm={12} md={6} style={{ width: '100%', paddingTop: "10px" }}>

                      <a href={googlePlayLink} target="_blank" rel="noopener noreferrer" style={{ marginRight: '10px', textDecoration: 'none', width: '100%' }}>
                        <Button variant="outlined" className={classes.buttondownload} fullWidth>
                          <img src="assets/images/icons/google-play.png" alt="google-play" width="20px" height="20px" style={{ marginRight: "5px" }} />
                          Download on Google Play
                        </Button>
                      </a></Grid>
                    <Grid item xs={12} sm={12} md={6} style={{ width: '100%', paddingTop: "10px" }}>

                      <a href={appStoreLink} target="_blank" rel="noopener noreferrer" style={{ marginLeft: '10px', textDecoration: 'none', width: '100%' }}>
                        <Button variant="outlined" className={classes.buttondownload} color="primary" fullWidth>
                          <img src="assets/images/icons/app-store.png" alt="app-store" width="20px" height="20px" style={{ marginRight: '5px' }} />
                          Download on the App Store
                        </Button>
                      </a>
                    </Grid>

                  </Grid>
                  <Divider style={{ paddingTop: "20px"  }}/>
                  <Grid container maxWidth="xl" style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>


                    <Grid item xs={2} sm={2} md={1} style={{ paddingTop: "10px", paddingRight: "5px" }}>

                      <a href={youtubeChannelLink} target="_blank" rel="noopener noreferrer" style={{ marginLeft: '10px', textDecoration: 'none' }}>
                        <img src="assets/images/icons/youtube.png" alt="youtube" width="60px" height="60px" style={{ marginRight: '5px' }} />
                      </a>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} style={{ paddingTop: "10px", paddingLeft: "25px" }}>

                      <a href="mailto:info@pictitude.com" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '10px', textDecoration: 'none' }}>
                        <img src="assets/images/icons/mail.png" alt="mail" width="30px" height="30px" style={{ marginRight: '5px' }} />
                      </a>
                    </Grid>
                  </Grid>
                </div>

              </Container>
            </Grid>
            <Grid item xs={12} sm={12} md={7} className='imagephone' style={{ display: 'flex', justifyContent: 'center', padding: '10px' }}>
              <img src="assets/images/bg/preview.jpg" width="300vh" alt="imageapp" style={{ padding: '10px', borderRadius: '26px ' }} />
              <img src="assets/images/bg/preview_2.jpg" width="300vh" alt="catpicphone" style={{ padding: '10px', borderRadius: '26px' }} />
            </Grid>
          </Grid>

        </div>
      </Grid>
    </Grid>



  );
}

const useStyles = makeStyles({ "name": { Home } })((theme) => ({

  root: {
    display: 'flex',
  },
  CardActions: {
    padding: '10px',
    "&:hover + $toggledElement": {
      backgroundColor: "black",
      display: "block"
    }
  },
  buttondownload: {
    fontSize: '13px',
    borderRadius: '50px',
    padding: '15px',
    color: 'white',
    background: theme.palette.primary.main,
    border: '2px solid white',
    "&:hover": {
      color: theme.palette.primary.main,
    }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    flex: '1 0 auto',
  },
  imageDescp: {
    width: '65%;',
    padding: '1%',
    transition: 'transform .2s',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    "&:hover": {
      transform: 'scale(1.2)',

    }
  },
  imageDotedDescp: {
    width: '50%;',
    padding: '5%',
    transition: 'transform .2s',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    "&:hover": {
      transform: 'scale(1.2)',

    }
  },
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {

    position: 'relative',
    zIndex: '9',
    display: 'flex',
    alignItems: 'center',
    backgroundSize: 'cover',
    backgroundPosition: '50%',
    backgroundRepeat: 'no-repeat',
    marginTop: '80px',
  },
  container: {

    paddingLeft: '0',
    paddingRight: '0',
    zIndex: '1',
    position: 'relative',
    marginBottom: '50px',
  },
  bigHeaderTypo: {
    fontFamily: 'ui-monospace',
    maxWidth: '250px',
    fontSize: '80px!important',
    lineHeight: '1.2!important',
    color: "white",
    backgroundColos: theme.palette.background.paper,
    marginBottom: '40px!important',
    marginTop: '5%!important',
    marginLeft: "auto",
    marginRight: "auto",

  },
  bigSubHeaderTypo: {
    fontFamily: 'Rochester',

    fontSize: '20px!important',
    lineHeight: '1.67!important',
    color: theme.palette.primary.main,
    marginBottom: '40px!important',
    marginTop: '10px!important',

    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
    fontWeight: '500'
  },
  bigHeaderImg: {
    height: '70px',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block'
  },
  bigHeadersubtitle: {
    color: "white",
    backgroundColos: theme.palette.background.paper,
    display: 'block',

    textAlign: "center",

    marginRight: "auto",
    marginLeft: "auto",
    width: 'fit-content',
    fontFamily: 'ui-monospace',
    fontSize: "40px!important"
  },

  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(8),
  },
  cardService: {
    position: 'relative',
    display: 'block',
    padding: '10px 60px',
    transition: 'all .25s cubic- bezier(.645, .045, .355, 1)',
    borderRadius: '5px',
    zIndex: '99',
    backgroundColor: '#fff!important',
    "&:hover": {
      transform: 'scale(1.05)',
      boxShadow: " 0 2.8px 2.2px rgba(0, 0, 0, 0.034),0 6.7px 5.3px rgba(0, 0, 0, 0.048),0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),0 41.8px 33.4px rgba(0, 0, 0, 0.086),0 100px 80px rgba(0, 0, 0, 0.12)",

    }

  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',

    "&:hover": {
      background: '#efefef!important',
      boxShadow: " 0 2.8px 2.2px rgba(0, 0, 0, 0.034),0 6.7px 5.3px rgba(0, 0, 0, 0.048),0 12.5px 10px rgba(0, 0, 0, 0.06), 0 22.3px 17.9px rgba(0, 0, 0, 0.072),0 41.8px 33.4px rgba(0, 0, 0, 0.086),0 100px 80px rgba(0, 0, 0, 0.12)",
      borderRadius: '5px'
    },
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },

  cotainerInfoNavigation: {
    marginTop: '100px',
    backgroundColor: '#F5F5F5',


  },

  divinfoNavigation: {

  },
  blocksTypo: {
    textAlign: 'center',
    color: '#383e56',
    paddingTop: '10px'

  },
  blocksTypoInfo: {
    textAlign: 'center',
    color: '#748494',
    paddingTop: '20px',
    fontSize: '18px!important'

  },
  divider: {
    backgroundColor: '#fb743e'
  },
  sectionTitleBorder: {
    width: '50px',
    height: '2px',
    marginRight: 'auto',
    marginLeft: 'auto',
    backgroundColor: '#fb743e',

  },
  IconsDivInfo: {
    fontSize: '2rem',

  },
  IconsDivInfoHolder: {
    width: '80px',
    padding: '20px',
    borderRadius: '50%',
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    background: 'white',
    color: '#206aa7',

    "&:hover": {
      background: '#206aa7',
      color: 'white',
      transform: 'rotate(360deg)',
      transition: 'width 2s, height 2s, transform 2s'

    },

  },
  list: {
    color: 'black',
    marginTop: '50px!important'
  },
  subitemIList: {
    lineHeight: '1.7!important',

    "&::before": {
      backgroundColor: '#fb743e !important',
      content: `''`,
      borderRadius: '50%',
      width: '7px',
      height: '7px',
      position: 'absolute',
      left: '0',
      top: '20px'
    },


  },
  cotainerListIfo: {
    backgroundColor: '#f8faff',
    padding: '10px'
  },
  containerWhiteBG: {
    backgroundColor: '#fff!important',
    margin: '2%!important'
  },
  containerDotBG: {
    backgroundColor: '#fff!important',
    backgroundImage: 'radial-gradient(circle, #cbcbcb  20%, transparent 10%), radial-gradient(circle, #cbcbcb  20%, transparent 10%)',
    backgroundSize: '10px 10px',
    backgroundPosition: '0 0, 50px 50px'
  }
}));

export default Home;